import { faqs } from "@/lib/siteData";
import { Reveal } from "./Primitives";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = () => (
  <section id="faq" className="relative mx-auto max-w-4xl px-4 py-24 md:px-8 md:py-32">
    <Reveal className="mb-12 text-center">
      <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-cyan-400">// Dúvidas</span>
      <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter md:text-5xl">
        Perguntas frequentes
      </h2>
    </Reveal>

    <Reveal>
      <Accordion type="single" collapsible className="space-y-3">
        {faqs.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            data-testid={`faq-item-${i}`}
            className="overflow-hidden rounded-2xl border border-white/8 bg-[#0F0F1A] px-6"
          >
            <AccordionTrigger className="py-5 text-left font-display text-base font-bold hover:text-[#a78bfa] hover:no-underline md:text-lg">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-5 font-body text-slate-400">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
